import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import '../../assets/css/form-style.css';
import ModalSearchFinancial from './ModalSearchFinancial';


class Tab1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dob: '',
            modalSearchVisible: false,
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        // this.handleDOBChange = this.handleDOBChange.bind(this);
    }

    inputChangeHandler(event) {
        this.props.changeState([event.target.name], event.target.value);
        this.setState({ [event.target.name]: event.target.value });
    }

    handleInputChange(event) {
        this.props.changeState([event.target.name], !this.props.data[event.target.name]);
    }

    render() {
        const { data } = this.props;
        return (
            <div className="col-md-12 print">
                <br />
                <p> * This form takes abouts 10 - 12 minutes to complete. Please ensure that you have the below documents scanned and ready for upload.</p>
                <br />
                <h4 className="info-text">Eligibility Criteria</h4>
                <div className="row">
                    <div className="col-sm-1 checkContainer text-content">
                        {/* <input
                            type="checkbox"
                            name="check4"
                            id="check4"
                            defaultChecked={data.check4}
                            onChange={this.handleInputChange}
                        /> */}
                        &bull;
                    </div>
                    <div className="col-sm-11 text-content">
                        Student is a Singapore Citizen (SC) or Singapore Permanent Resident (SPR)
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-1 checkContainer text-content">
                        {/* <input type="checkbox" name="check5" id="check5" defaultChecked={data.check5} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-11 text-content">
                        Family is living in a 4-room HDB flat or smaller
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-1 checkContainer text-content">
                        {/* <input type="checkbox" name="check6" id="check6" defaultChecked={data.check6} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-11 text-content">
                        Family has a gross per capita income (PCI) of $690/ month or less (PCI eligibility to be updated to $750/month or less for applications in 2024)
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-1 checkContainer text-content">
                        {/* <input type="checkbox" name="check7" id="check7" defaultChecked={data.check7} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-11 text-content">
                        Student is receiving full-time formal education in a mainstream primary/ secondary/ mixed level/ Junior College/ Centralized institute; Independent; SPED; Institutes of Technical Education; Polytechnic; Specialised; Specialised Independent; MOE-designated full-time Madrasahs and Mountbatten Vocational School
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-1 checkContainer text-content">
                        {/* <input type="checkbox" name="check7" id="check7" defaultChecked={data.check7} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-11 text-content">
                        Is not concurrently receiving school pocket money fund from disbursing agencies/schools
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-1 checkContainer text-content">
                        {/* <input type="checkbox" name="check8" id="check8" defaultChecked={data.check8} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-11 text-content">
                        Is currently not receiving STSPMF or financial assistance from other similar schemes (Student receiving financial assistance from MOE may apply).
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState({ modalSearchVisible: true });
                            }}
                            style={{ textDecoration: 'underline' }}
                        >
                            &nbsp;Check here.
                        </a>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-1 checkContainer text-content">
                        {/* <input type="checkbox" name="check9" id="check9" defaultChecked={data.check9} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-11 text-content">
                        Has not previously received more than 24 months of STSPMF in primary and secondary school levels and 48 months in post-secondary level.
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState({ modalSearchVisible: true });
                            }}
                            style={{ textDecoration: 'underline' }}
                        >
                            &nbsp;Check here.
                        </a>
                    </div>
                </div>
                <hr className="dashed" />
                <h4 className="info-text"><b>Please ensure you have the following documents with you before completing the form. Your application form must be attached with the relevant documents listed below:</b></h4>
                <div className="row">
                    <div className="col-sm-1 checkContainer text-content">
                        {/* <input type="checkbox" name="check1" id="check1" defaultChecked={data.check1} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-11 text-content">
                        Soft copy of student(s)&#39;s birth certificate (for students aged 15 and below) or NRIC (for students aged 15 to 21).
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-1 checkContainer text-content">
                        {/* <input type="checkbox" name="check2" id="check2" defaultChecked={data.check2} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-11 text-content">
                        Soft copy of both parents&#39; or guardian&#39;s and all household members&#39; NRIC or passport
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-1 checkContainer text-content">
                        {/* <input type="checkbox" name="check2" id="check2" defaultChecked={data.check2} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-11 text-content">
                        Latest documentary evidence of gross household income of every member of the household (exclude school going children in the household) eg: latest payslips and CPF statements for the past 3 months (My Contribution, My Statement and Transaction History) or income declaration*
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-2 checkContainer text-content"></div>
                    <div className="col-sm-10 text-content">
                        For household members who are employed, regardless of age
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3 checkContainer text-content">
                        {/* <input type="checkbox" name="check2" id="check2" defaultChecked={data.check2} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-9 text-content">
                        Latest payslip/ letter from employer certifying gross monthly income; and
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3 checkContainer text-content">
                        {/* <input type="checkbox" name="check2" id="check2" defaultChecked={data.check2} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-9 text-content">
                        CPF Contribution History for the past 3 months
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-2 checkContainer text-content"></div>
                    <div className="col-sm-10 text-content">
                        For household members who are unemployed or retired, aged 62 years and below
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3 checkContainer text-content">
                        {/* <input type="checkbox" name="check2" id="check2" defaultChecked={data.check2} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-9 text-content">
                        CPF Contribution History for the past 3 months
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-2 checkContainer text-content"></div>
                    <div className="col-sm-10 text-content">
                        For household members who are self-employed, private-hire drivers and food-delivery riders
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3 checkContainer text-content">
                        {/* <input type="checkbox" name="check2" id="check2" defaultChecked={data.check2} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-9 text-content">
                        CPF Contribution History for the past 3 months; and
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3 checkContainer text-content">
                        {/* <input type="checkbox" name="check2" id="check2" defaultChecked={data.check2} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-9 text-content">
                        Income Declaration Form Part A (for self-employed persons who are not required to pay tax)
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3 checkContainer text-content">
                        {/* <input type="checkbox" name="check2" id="check2" defaultChecked={data.check2} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-9 text-content">
                        Income Slip of the last 3 months (applicable for private-hire drivers and food-delivery riders only)
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-2 checkContainer text-content"></div>
                    <div className="col-sm-10 text-content">
                        For household members who are non-Singaporean or PR
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3 checkContainer text-content">
                        {/* <input type="checkbox" name="check2" id="check2" defaultChecked={data.check2} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-9 text-content">
                        Income Declaration Form Part B; and
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3 checkContainer text-content">
                        {/* <input type="checkbox" name="check2" id="check2" defaultChecked={data.check2} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-9 text-content">
                        Latest payslip, if employed
                    </div>
                </div>
                <h4 className="info-text">Additional criteria for students studying in JC,ITE or Polytechnic and applying for STSPMF</h4>
                <div className="row">
                    <div className="col-sm-1 checkContainer text-content">
                        {/* <input type="checkbox" name="check10" id="check10" defaultChecked={data.check10} onChange={this.handleInputChange} /> */}
                        &bull;
                    </div>
                    <div className="col-sm-11 text-content">
                        Student is 20 years or younger at point of application
                    </div>
                </div>
                <br />
                <p className="red">STSPMF reserves the right to reject the application if any of the supporting documents is not submitted</p>
                <br />
                <ModalSearchFinancial
                    visible={this.state.modalSearchVisible}
                    onClose={() => this.setState({ modalSearchVisible: false })}
                />
            </div>
        );
    }
}

Tab1.propTypes = {
    changeState: PropTypes.func,
};
Tab1.defaultProps = {
    changeState: () => null,
};


const mapDispatchToProps = dispatch => ({
});

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
});

export default connect(mapStateToProps, mapDispatchToProps)(Tab1);



//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/tab1.js
// module id = 1041
// module chunks = 0